import { render, staticRenderFns } from "./template/boat-type-info.html?vue&type=template&id=6bc2e06b&scoped=true&external"
import script from "./BoatTypeInfo.vue?vue&type=script&lang=js"
export * from "./BoatTypeInfo.vue?vue&type=script&lang=js"
import style0 from "./BoatTypeInfo.vue?vue&type=style&index=0&id=6bc2e06b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc2e06b",
  null
  
)

export default component.exports